import { render, staticRenderFns } from "./BuyingRequests.vue?vue&type=template&id=7bd97ddc&"
import script from "./BuyingRequests.vue?vue&type=script&lang=js&"
export * from "./BuyingRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports